import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { BriefType } from '../../molecules/conversation/smart-brief-conversation';

@Component({
  selector: 'cbss-brief-type',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './a-brief-type.html',
  styleUrl: './a-brief-type.scss',
})
export class CreateBriefSelectSmartBriefType {
  readonly chosen = output<BriefType>();

  readonly briefTypes: {
    briefType: BriefType;
    name: string;
    description: string;
    youGet: string;
  }[] = [
    {
      briefType: 'ugc',
      name: 'UGC Content Brief',
      description: 'Creators make original video content for your brand, to use in your own ads or posted on their own socials.',
      youGet: 'You get videos & posts'
    },
    {
      briefType: 'screening',
      name: 'Social Screening Brief',
      description: "AI reviews creators' past posts (up to 1 year back) against your requirements and red flags before you work with them.",
      youGet: 'You get a vetting report per creator'
    },
    {
      briefType: 'monitoring',
      name: 'Social Monitoring Brief',
      description: "AI keeps watching creators' posts over a live window, from up to 30 days ago to a year ahead, and flags anything off-brief.",
      youGet: 'You get ongoing alerts & reports'
    },
  ];

  choose(briefType: BriefType): void {
    this.chosen.emit(briefType);
  }

}
